export default __webpack_public_path__ + "static/media/sms-icon.7ffa6cfe.svg";